import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from 'app/routes/app.routes';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root',
})
export class SpecializationService {
  private baseUrl = ApiRoutes.api.baseUrl;
  private routes = ApiRoutes.api;
  constructor(private http: HttpClient, private httpService: HttpService) {}

  addSpecialization(payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.specialization.add,
      method: 'post',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  allSpecializations(pagination?: { page?: number; limit?: number }) {
    const params: any = {};
    
    if (pagination) {
      if (pagination.page) params.page = pagination.page;
      if (pagination.limit) params.limit = pagination.limit;
    }
    
    return this.httpService.makeRequest({
      path: this.routes.specialization.retrieve,
      method: 'get',
      options: { params },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  editSpecialization(id: string, payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.specialization.edit,
      method: 'put',
      options: { id, body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  deleteSpecialization(id: string) {
    return this.httpService.makeRequest({
      path: this.routes.specialization.delete,
      method: 'delete',
      options: { id },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  bulkDelete(payload: { ids: number[] }) {
    return this.httpService.makeRequest({
      path: this.routes.specialization.bulkDelete,
      method: 'delete',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getSpecializationDetails(id: number) {
    return this.httpService.makeRequest({
      path: this.routes.specialization.retrieveSingle,
      method: 'get',
      options: { id },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }
}
